import { render, staticRenderFns } from "./LeaveDaysBalances.vue?vue&type=template&id=15df3447&scoped=true"
import script from "./LeaveDaysBalances.vue?vue&type=script&lang=js"
export * from "./LeaveDaysBalances.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15df3447",
  null
  
)

export default component.exports